import { Dispatch } from "redux";
import api from "../../api/api";
import {
     setgetCourse,
    setloading,
    seterror,
    setCompetitiveExamScores,
    resetgetCompetitiveExamScore
} from "../reducers/getCompetativeExamScoreReducer";

const getCompetitiveExamScores = (data: any, token: any) => async (
    dispatch: Dispatch
) => {
    dispatch(setloading(true));
    try {
        const result = await api.post(`/competitive/get-competitive-exam-scores/`, data,{
            headers: {
                "Content-Type": "application/json",
                Authorization: `Token ${token}`,
            },
        });

        console.warn('result',result);
        

        if (result) {
            console.log("result");
            
            dispatch(setloading(false));
            if (result.data?.status === 200) {
                dispatch(setCompetitiveExamScores(result.data.data));

                
            } else if (result.data?.status === 404) {
                dispatch(seterror("No scores found for this student in the given course."));
            } else {
                dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
        }
        }
    } catch (error: any) {
        dispatch(setloading(false));
        dispatch(seterror(error.response?.data?.message ?? "Something Went Wrong!"));
    }
};

export { getCompetitiveExamScores, resetgetCompetitiveExamScore };

